const reportData = [
  {
    key: '1',
    period: 'Period 0',
    round: 'Round 1',
    actualElvs: 10,
    openingBooks: 0,
    processed: 2000,
    dispatched: 1000,
    roundExcessDeficit: 1000,
    closingBooks: 1000,
    physicalInventory: 900,
    periodExcessDeficit: 1000,
    mismatchError: -100,
    fifoElvs: 5,
    roundElvs: 10,
  },
  {
    key: '2',
    period: 'Period 1',
    round: 'Round 1',
    actualElvs: 2,
    openingBooks: 1000,
    processed: 400,
    dispatched: 450,
    roundExcessDeficit: -50,
    closingBooks: 950,
    physicalInventory: null,
    periodExcessDeficit: null,
    mismatchError: null,
    fifoElvs: 2,
    roundElvs: 2,
  },
  {
    key: '3',
    period: 'Period 1',
    round: 'Round 2',
    actualElvs: 2,
    openingBooks: null,
    processed: 400,
    dispatched: 525,
    roundExcessDeficit: -125,
    closingBooks: 825,
    physicalInventory: null,
    periodExcessDeficit: null,
    mismatchError: null,
    fifoElvs: 3,
    roundElvs: 2,
  },
  {
    key: '4',
    period: 'Period 1',
    round: 'Round 3',
    actualElvs: 3,
    openingBooks: null,
    processed: 600,
    dispatched: 600,
    roundExcessDeficit: 0,
    closingBooks: 825,
    physicalInventory: 1035,
    periodExcessDeficit: -175,
    mismatchError: 210,
    fifoElvs: 3,
    roundElvs: 3,
  },
  {
    key: '5',
    period: 'Period 2',
    round: 'Round 1',
    actualElvs: 2,
    openingBooks: 825,
    processed: 400,
    dispatched: 1500,
    roundExcessDeficit: -1100,
    closingBooks: -275,
    physicalInventory: null,
    periodExcessDeficit: null,
    mismatchError: null,
    fifoElvs: 8,
    roundElvs: 2,
  },
  {
    key: '6',
    period: 'Period 2',
    round: 'Round 2',
    actualElvs: 2,
    openingBooks: null,
    processed: 400,
    dispatched: 500,
    roundExcessDeficit: -100,
    closingBooks: -375,
    physicalInventory: 0,
    periodExcessDeficit: -1200,
    mismatchError: 375,
    fifoElvs: 3,
    roundElvs: 2,
  },
  {
    key: '7',
    period: 'Period 3',
    round: 'Round 1',
    actualElvs: 1,
    openingBooks: -375,
    processed: 200,
    dispatched: 150,
    roundExcessDeficit: 50,
    closingBooks: -325,
    physicalInventory: 0,
    periodExcessDeficit: 50,
    mismatchError: 325,
    fifoElvs: 1,
    roundElvs: 1,
  },
]

const bucketsList = [
  { label: 'job_Doors', value: 'Doors' },
  { label: 'job_Dicky', value: 'Dicky' },
  { label: 'job_ShellAndPaintedSteel', value: 'Shell and Painted Steel' },
  { label: 'inv_DrumBrake', value: 'Drum brake' },
  { label: 'inv_Bumper', value: 'Bumper' },
  { label: 'job_Battery', value: 'Battery' },
  { label: 'inv_CatalyticConverter', value: 'Catalytic Converter' },
  { label: 'inv_TyresRubber', value: 'Tyres & Rubber' },
  { label: 'job_HazardousMaterial', value: 'Hazardous Material' },
  { label: 'inv_SeatFoam', value: 'Seat Foam' },
  { label: 'job_Aluminium', value: 'Aluminium' },
  { label: 'job_Muffler', value: 'Muffler' },
  { label: 'job_SteelCasting', value: 'Steel Casting' },
  { label: 'inv_SteelScrap', value: 'Steel Scrap' },
  { label: 'inv_Fastner', value: 'Fastner' },
  { label: 'job_Plastic', value: 'Plastic' },
  { label: 'job_Glasses', value: 'Glasses' },
  { label: 'inv_MixMotors', value: 'Mix Motors' },
  { label: 'inv_WasteOil', value: 'Waste Oil' },
  { label: 'inv_EWaste', value: 'E-Waste' },
  { label: 'inv_Misc', value: 'Misc' },
  { label: 'inv_OuterBodyParts', value: 'Outer Body Parts' },
  { label: 'inv_InnerBodyParts', value: 'Inner Body Parts' },
  { label: 'inv_ProcessLoss', value: 'Process Loss' },
  { label: 'inv_FullEngine', value: 'Full Engine' },
  { label: 'inv_HeadAndTailLights', value: 'Head and Tail Light' },
  { label: 'job_Converter', value: 'Converter' },
  { label: 'job_DoorsDicky', value: 'Doors, Dicky' },
  { label: 'job_RubberAndTyres', value: 'Rubber and Tyres' },
  { label: 'job_AlCastings', value: 'Al Castings' },
  { label: 'job_AlAlloy', value: 'Al Alloy' },
  { label: 'job_AlRadiators', value: 'Al Radiators' },
  { label: 'job_LeadAcidBattery', value: 'Lead Acid Battery' },
  { label: 'job_UsedParts', value: 'Used Parts' },
  { label: 'job_WireHarness', value: 'Wire Harness' },
  { label: 'job_HeadTailLights', value: 'Head & Tail Lights' },
  { label: 'job_UsedDoors', value: 'Used Doors' },
  { label: 'job_UsedHoodDicky', value: 'Used Hood & Dicky' },
  { label: 'job_UsedSeats', value: 'Used Seats' },
  { label: 'job_EngineParts', value: 'Engine Parts' },
  { label: 'job_EVBattery', value: 'EV Battery' },
  { label: 'job_Oils', value: 'Oils' },
  { label: 'job_Foam', value: 'Foam' },
]

const dealerList = [
  {
    label: 'RANA MOTORS PVT LTD',
    value: 'RANA MOTORS PVT LTD',
  },
  {
    label: 'T.R. SAWHNEY AUTOMOBILES PVT LTD',
    value: 'T.R. SAWHNEY AUTOMOBILES PVT LTD',
  },
]

const reportExportExcelOptions = [
  { label: 'inv_Period', value: 'Period' },
  { label: 'rpt_Round', value: 'Round' },
  {
    label: 'rpt_ActualNumberOfELVsLinkedToThisRound',
    value: 'Actual number of ELVs linked to this round',
  },
  {
    label: 'rpt_OpeningAsPerBooksActual',
    value: 'Opening as per Books (Actual)',
  },
  { label: 'tag_ProcessedActual', value: 'Processed (Actual)' },
  { label: 'rpt_Dispatched', value: 'Dispatched' },
  { label: 'rpt_RoundExcessDeficit', value: 'Round Excess/Deficit' },
  {
    label: 'rpt_ClosingAsPerBooksActual',
    value: 'Closing as per Books (Actual)',
  },
  {
    label: 'rpt_PhysicalInventoryLeftAtTheEndOfThePeriod',
    value: 'Physical Inventory left at the end of the period',
  },
  {
    label: 'rpt_PeriodExcessDeficitAsPerBooksActual',
    value: 'Period Excess/Deficit as per Books (Actual)',
  },
  {
    label: 'rpt_MismatchError',
    value:
      'Mismatch (Error) (Physical inventory less closing inventory as per books)',
  },
  {
    label: 'rpt_FIFOELVs',
    value: 'FIFO ELVs (Processed and connected to DISPATCHED)',
  },
  { label: 'rpt_RoundELVs', value: 'Round ELVs' },
]

const salesReportData = [
  {
    key: '1',
    evNo: 'EV-JAN25-419',
    dealer: 'RANA MOTORS PVT LTD',
    location: 'Jaipur',
    channel: 'NEXA',
    consumer: 'Suresh Kumar',
    regNo: 'RJ02CA6850',
    model: 'Maruti Ritz',
    fuel: 'Diesel',
    buyingPrice: '₹ 35,000.00',
    baseBuyingPrice: '₹ 38,000.00',
    baseCommission: '₹ 4,000.00',
    commission: '₹ 7,000.00',
    additionalIncentive: '₹ 2,000.00',
    total: '₹ 9,000.00',
  },
  {
    key: '2',
    evNo: 'EV-JAN25-420',
    dealer: 'RANA MOTORS PVT LTD',
    location: 'Jaipur',
    channel: 'NEXA',
    consumer: 'Tarun Kumar',
    regNo: 'RJ13CD1926',
    model: 'Alto LX',
    fuel: 'Petrol',
    buyingPrice: '₹ 17,000.00',
    baseBuyingPrice: '₹ 21,000.00',
    baseCommission: '₹ 4,000.00',
    commission: '₹ 4,000.00',
    additionalIncentive: '₹ 2,000.00',
    total: '₹ 6,000.00',
  },
  {
    key: '3',
    evNo: 'EV-FEB01-102',
    dealer: 'RANA MOTORS PVT LTD',
    location: 'Jaipur',
    channel: 'NEXA',
    consumer: 'Somu Sharma',
    regNo: 'RJ10L8693',
    model: 'Innova',
    fuel: 'Diesel',
    buyingPrice: '₹ 87,000.00',
    baseBuyingPrice: '₹ 87,000.00',
    baseCommission: '₹ 4,000.00',
    commission: '₹ 4,000.00',
    additionalIncentive: '₹ 950.00',
    total: '₹ 4,950.00',
  },
  {
    key: '4',
    evNo: 'EV-FEB01-103',
    dealer: 'RANA MOTORS PVT LTD',
    location: 'Jaipur',
    channel: 'NEXA',
    consumer: 'Rakesh Singla',
    regNo: 'RJ06CL1015',
    model: 'Chevrolet Spark LS',
    fuel: 'Petrol',
    buyingPrice: '₹ 22,000.00',
    baseBuyingPrice: '₹ 22,000.00',
    baseCommission: '₹ 4,000.00',
    commission: '₹ 4,000.00',
    additionalIncentive: '₹ 950.00',
    total: '₹ 4,950.00',
  },
  {
    key: '5',
    evNo: 'EV-MAR03-401',
    dealer: 'RANA MOTORS PVT LTD',
    location: 'Jaipur',
    channel: 'NEXA',
    consumer: 'Satish Kumar',
    regNo: 'RJ05Q9021',
    model: 'Wagon R',
    fuel: 'Petrol',
    buyingPrice: '₹ 23,000.00',
    baseBuyingPrice: '₹ 23,000.00',
    baseCommission: '₹ 4,000.00',
    commission: '₹ 4,000.00',
    additionalIncentive: '₹ 950.00',
    total: '₹ 4,950.00',
  },
  {
    key: '6',
    evNo: 'EV-MAR03-402',
    dealer: 'RANA MOTORS PVT LTD',
    location: 'Jaipur',
    channel: 'NEXA',
    consumer: 'Ajay Kumar',
    regNo: 'RJ02C1009',
    model: 'Verna 1.6 CRDI SX',
    fuel: 'Diesel',
    buyingPrice: '₹ 40,000.00',
    baseBuyingPrice: '₹ 40,000.00',
    baseCommission: '₹ 4,000.00',
    commission: '₹ 5,000.00',
    additionalIncentive: '₹ 1,000.00',
    total: '₹ 6,000.00',
  },
  {
    key: '7',
    evNo: 'EV-MAR03-403',
    dealer: 'RANA MOTORS PVT LTD',
    location: 'Jaipur',
    channel: 'NEXA',
    consumer: 'Mandeep Ram',
    regNo: 'RJ5CA4421',
    model: 'Getz-GLS',
    fuel: 'Petrol',
    buyingPrice: '₹ 32,000.00',
    baseBuyingPrice: '₹ 32,000.00',
    baseCommission: '₹ 4,000.00',
    commission: '₹ 4,000.00',
    additionalIncentive: '₹ 1,000.00',
    total: '₹ 5,000.00',
  },
  {
    key: '8',
    evNo: 'EV-MAR03-404',
    dealer: 'RANA MOTORS PVT LTD',
    location: 'Jaipur',
    channel: 'NEXA',
    consumer: 'Rohit Sharma',
    regNo: 'RJ03CA5900',
    model: 'Maruti 800 STD',
    fuel: 'Petrol',
    buyingPrice: '₹ 13,000.00',
    baseBuyingPrice: '₹ 13,000.00',
    baseCommission: '₹ 2,000.00',
    commission: '₹ 2,000.00',
    additionalIncentive: '₹ 950.00',
    total: '₹ 2,950.00',
  },
]

const filterKeys = {
  assignee: 'assignee',
  vehicleCategory: 'vehicleCategory',
  vehicleProducer: 'vehicleProducer',
  vehicleModel: 'vehicleModel',
  vehicleSource: 'vehicleSource',
  vehicleType: 'vehicleType',
  vehicleStatus: 'vehicleStatus',
  rcAvailability: 'rcAvailability',
  beneficiary: 'beneficiary',
  dealerName: 'dealerName',
  dealerLocation: 'dealerLocation',
  dealerChannel: 'dealerChannel',
  dateFilter: 'dateFilter',
  jobCompleted: 'jobCompleted',
}

export {
  reportData,
  bucketsList,
  dealerList,
  reportExportExcelOptions,
  salesReportData,
  filterKeys,
}
